(() => {
  function initAnimations() {
    gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin, ScrollSmoother);

    /* --- Global Scroll Settings --- */
    const isTouch = () => window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.maxTouchPoints > 0;
    const mm = gsap.matchMedia();
    const globalBreakpoint = 1024;
    const styles = getComputedStyle(document.body);
    const navHeight = styles.getPropertyValue('--nav-height');
    let smoother;

    mm.add(
      {
        isDesktop: `(min-width: ${globalBreakpoint}px)`,
      },
      (context) => {
        const { isDesktop } = context.conditions;
        if (isDesktop && !isTouch()) {
          smoother = ScrollSmoother.create({
            smooth: 0.5, // default is 0.8
            effects: false,
            normalizeScroll: {
              allowNestedScroll: true,
            },
            smoothTouch: false,
          });

          window.addEventListener('load', () => {
            const urlHashMatch = window.location.hash.match(/(#?[A-Za-z][A-Za-z0-9-_:.]*)/);
            let urlHash = urlHashMatch ? urlHashMatch[1] : null;

            if (!urlHash) return;

            if (!urlHash.startsWith('#')) urlHash = `#${urlHash}`;

            const scrollElem = document.querySelector(urlHash);

            if (!scrollElem) return;

            gsap.to(smoother, {
              scrollTop: smoother.offset(scrollElem, `top top+=${navHeight}px`),
              duration: 1,
              delay: 0.5,
            });
          });

          scrollSmootherAnchorLinks();
        }
      },
    );

    /* --- Global Animations --- */
    function scrollSmootherAnchorLinks() {
      const anchorLinks = gsap.utils.toArray('a[href*="#"]');

      if (anchorLinks.length === 0) {
        // console.warn('No anchor links found.');
        return;
      }

      const currentLocation = window.location;
      const validAnchorHrefs = [
        currentLocation.origin,
        `http://${currentLocation.host}`,
        `http://www.${currentLocation.host}`,
        `https://${currentLocation.host}`,
        `https://www.${currentLocation.host}`,
        '//localhost:3001',
      ];

      anchorLinks.forEach((link) => {
        const linkHref = link.href;

        if (!validAnchorHrefs.some((v) => linkHref.startsWith(v)) && !linkHref.includes('#')) {
          // console.warn('Skipping invalid anchor link:', link);
          return;
        }

        link.addEventListener('click', (e) => {
          e.preventDefault();

          let id = linkHref.split('#')[1];

          if (!id) return;

          id = id.includes('#') ? id : `#${id}`;

          const target = document.querySelector(id);

          if (!target) {
            // Target not found on page, so redirect to the link
            // console.log('Target element not found on page:', id);
            window.location = linkHref;
            return;
          }

          smoother.scrollTo(id, true, `top top+=${navHeight}px`);
          // Update page URL with hash
          window.history.pushState({}, '', id);
        });
      });
    }

    function textHighlight() {
      const textHighlightClasses = ['highlight-white-lilac', 'highlight-white-lilac-transparent', 'highlight-eggshell-blue'];
      const textHighlights = gsap.utils.toArray('em');

      if (textHighlights.length === 0) {
        // console.warn('No <em> elements found.');
        return;
      }

      textHighlights.forEach((em) => {
        const parent = em.parentElement;

        if (!parent) {
          // console.warn('Parent element not found for <em> element:', em);
          return;
        }

        const hasHighlightClass = textHighlightClasses.some((c) => parent.classList.contains(c));

        if (!hasHighlightClass) {
          // console.log('Skipping <em> element without required class:', em);
          return;
        }

        ScrollTrigger.create({
          trigger: em,
          start: '-100px center',
          rotation: 0.01,
          onEnter: () => em.classList.add('active'),
          stagger: 0.15,
          // markers: true,
        });
      });
    }
    textHighlight();

    function cardStagger() {
      const cardElements = gsap.utils.toArray('.card-feature-large, .card-feature');

      if (cardElements.length === 0) {
        // console.warn('No .card-stagger elements found.');
        return;
      }

      const breakpoint = cardElements[0].parentElement.dataset.breakpoint;
      if (!breakpoint) return;

      function cardOffset(el, elIndex) {
        const isIndexZero = elIndex === 0;
        let offsetValue = 50;

        if (cardElements.length >= 3) {
          const pairIndex = Math.floor(elIndex / 2);
          offsetValue = pairIndex % 2 === 0 ? 50 : 100;
        }

        const tl = gsap.timeline({
          yoyo: true,
          scrollTrigger: {
            trigger: el.parentElement,
            scrub: 2,
            start: () => 'top bottom-=100px',
            end: () => 'bottom bottom-=100px',
            // Cannot get clamp to work as expected
            // start: 'clamp(top bottom)',
            // end: 'clamp(bottom top)',
            // markers: true,
            // onRefresh: (self) => {
            //   console.log('clamped', self.start, self.end);
            // },
          },
        });

        tl.fromTo(
          el,
          {
            opacity: 0.25,
            y: isIndexZero ? 0 : offsetValue * -0.25,
          },
          {
            opacity: 1,
            y: isIndexZero ? 0 : offsetValue,
            ease: 'linear',
          },
        );
      }

      mm.add(
        {
          isDesktop: `(min-width: ${breakpoint}px)`,
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          const { isDesktop, reduceMotion } = context.conditions;
          if (isDesktop && !reduceMotion) {
            cardElements.forEach((card, index) => cardOffset(card, index));
          }
        },
      );
    }
    cardStagger();

    function fadeIn() {
      const fadeInElements = gsap.utils.toArray('.pagefx-fade-in');

      if (fadeInElements.length === 0) return;

      const breakpoint = 1024;

      mm.add(
        {
          isDesktop: `(min-width: ${breakpoint}px)`,
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          const { isDesktop, reduceMotion } = context.conditions;
          if (!reduceMotion) {
            if (isDesktop) {
              gsap.set(fadeInElements, { opacity: 0, y: 25 });
            }

            ScrollTrigger.batch(fadeInElements, {
              interval: 0.1, // time window (in seconds) for batching to occur.
              batchMax: 3, // maximum batch size (targets). Can be function-based for dynamic values
              onEnter: (batch) => {
                gsap.to(
                  batch,
                  {
                    opacity: 1,
                    y: 0,
                    stagger: 0.1,
                    duration: 0.5,
                    overwrite: true,
                  },
                );
              },
              start: () => '20px bottom',
              end: () => 'top top',
            });

            ScrollTrigger.addEventListener('refreshInit', () => gsap.set(fadeInElements, { y: 0 }));
          }
        },
      );
    }
    fadeIn();

    function imageBackgroundParallax() {
      const imageBackgrounds = gsap.utils.toArray('.image-background__image, .block-background-image__image');

      if (imageBackgrounds.length === 0) {
        // console.warn('No .parallax elements found.');
        return;
      }

      const breakpoint = 1024;

      mm.add(
        {
          isDesktop: `(min-width: ${breakpoint}px)`,
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          const { isDesktop, reduceMotion } = context.conditions;
          if (isDesktop && !reduceMotion) {
            imageBackgrounds.forEach((el) => {
              const bkgYStart = el.dataset.parallaxYStart || 75;
              const bkgYEnd = el.dataset.parallaxYEnd || 75;
              const tl = gsap.timeline({
                yoyo: true,
                scrollTrigger: {
                  trigger: el,
                  scrub: 2,
                  start: () => 'top center-=100px',
                  end: () => 'bottom center',
                  // markers: true,
                },
              });

              tl.fromTo(
                el,
                {
                  backgroundPosition: `50% ${bkgYStart * -1}px`,
                },
                {
                  backgroundPosition: `50% ${bkgYEnd * 1}px`,
                  ease: 'linear',
                  overwrite: 'auto',
                },
                '>',
              );
            });
          }
        },
      );
    }
    imageBackgroundParallax();

    function iconFeatureIconBounce() {
      const iconFeatureIcons = gsap.utils.toArray('.icon-feature__image');

      if (iconFeatureIcons.length === 0) return;

      gsap.set(iconFeatureIcons, { opacity: 0, y: -50 });

      ScrollTrigger.batch(iconFeatureIcons, {
        interval: 0.1, // time window (in seconds) for batching to occur.
        batchMax: 3, // maximum batch size (targets). Can be function-based for dynamic values
        onEnter: (batch) => {
          gsap.to(
            batch,
            {
              opacity: 1,
              y: 0,
              ease: 'bounce.out',
              duration: 1,
              stagger: 0.1,
            },
          );
        },
        start: () => 'clamp(top-=350px center+=100px)',
        end: () => 'clamp(top top)',
        // markers: true,
      });

      ScrollTrigger.addEventListener('refreshInit', () => gsap.set(iconFeatureIcons, { y: 0 }));
    }
    iconFeatureIconBounce();

    function parallax() {
      const parallaxElements = gsap.utils.toArray('.pagefx-parallax');

      if (parallaxElements.length === 0) {
        // console.warn('No .parallax elements found.');
        return;
      }

      const breakpoint = 1024;

      mm.add(
        {
          isDesktop: `(min-width: ${breakpoint}px)`,
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          const { isDesktop, reduceMotion } = context.conditions;
          if (isDesktop && !reduceMotion) {
            const masterParallaxTl = gsap.timeline();

            parallaxElements.forEach((el, i) => {
              const yPercentValue = el.dataset.parallaxY || 25;
              let triggerEl = el.dataset.parallaxTrigger;
              if (triggerEl === 'element') {
                triggerEl = el;
              } else if (triggerEl === 'parent') {
                triggerEl = el.parentElement;
              } else {
                triggerEl = el.closest('.container') || el.closest('section');
              }
              const tl = gsap.timeline({
                yoyo: true,
                scrollTrigger: {
                  trigger: triggerEl,
                  scrub: 2,
                  start: () => 'clamp(top center-=100px)',
                  end: () => 'clamp(bottom center+=100px)',
                  // markers: true,
                },
              });

              tl.fromTo(
                el,
                {
                  rotation: 0.01,
                  yPercent: yPercentValue * -1,
                },
                {
                  rotation: 0.01,
                  yPercent: yPercentValue,
                  ease: 'linear',
                  delay: i * 0.5 ? 0 : 0.5,
                  duration: 1,
                },
                '>',
              );

              masterParallaxTl.add(tl);
            });

            masterParallaxTl.play();
          }
        },
      );
    }
    parallax();

    function blobAnimation() {
      const blobs = gsap.utils.toArray('.blob');

      if (blobs.length === 0) {
        // console.warn('No .blob elements found.');
        return;
      }

      /* eslint no-unused-vars: "off" */
      mm.add(
        {
          isDesktop: `(min-width: ${globalBreakpoint}px)`,
          isMobile: `(max-width: ${globalBreakpoint - 1}px)`,
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          // eslint disable no-unused-vars
          const { isDesktop, isMobile, reduceMotion } = context.conditions;
          if (!reduceMotion) {
            const masterBlobTl = gsap.timeline();

            blobs.forEach((blob, i) => {
              const rotateValue = blob.style.getPropertyValue('--blob-rotation') || 0.01;
              const tl = gsap.timeline({
                yoyo: true,
                scrollTrigger: {
                  trigger: blob,
                  scrub: 3,
                  start: () => `clamp(top bottom-=${i * 200 ? 0 : 100}px)`,
                  end: () => `clamp(bottom top+=${i * 200 ? 0 : 100}px)`,
                  onEnter: () => blob.classList.add('is-visible'),
                  onEnterBack: () => blob.classList.add('is-visible'),
                  onLeave: () => blob.classList.remove('is-visible'),
                  onLeaveBack: () => blob.classList.remove('is-visible'),
                  // markers: true,
                },
              });

              tl.fromTo(
                blob,
                {
                  rotation: rotateValue,
                  yPercent: -10,
                },
                {
                  rotation: rotateValue,
                  yPercent: 25,
                  ease: 'linear',
                  delay: i * 0.25 ? 0 : 0.25,
                },
              );

              masterBlobTl.add(tl);
            });

            masterBlobTl.play();
          }
        },
      );
    }
    blobAnimation();

    function waveAnimation() {
      const waves = gsap.utils.toArray('.wave-morph');

      if (waves.length === 0) {
        // console.warn('No .parallax elements found.');
        return;
      }

      const breakpoint = 1024;

      mm.add(
        {
          isDesktop: `(min-width: ${breakpoint}px)`,
          reduceMotion: '(prefers-reduced-motion: reduce)',
        },
        (context) => {
          const { isDesktop, reduceMotion } = context.conditions;
          if (isDesktop && !reduceMotion) {
            waves.forEach((wave) => {
              const waveParent = wave.parentElement;
              const waveTrigger = waveParent.querySelector('.container') || waveParent.querySelector('[class*="container"]');
              wave.pathStart = wave.querySelector('.wave-path-start');
              wave.pathEnd = wave.querySelector('.wave-path-end');
              const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: waveTrigger,
                  start: () => `clamp(top ${wave.classList.contains('wave-morph--top') ? 'center' : 'top'})`,
                  end: () => 'clamp(bottom bottom+=250px)',
                  scrub: 3,
                  // markers: true,
                },
                defaults: { duration: 1, ease: 'linear' },
              });

              tl.to(wave.pathStart, {
                rotation: 0.01,
                morphSVG: wave.pathEnd,
              });
            });
          }
        },
      );
    }
    waveAnimation();
  }
  initAnimations();
})();
